export async function getBitcoinPublicKeyFromConnector(connector) {
    if (connector.type !== "orangekit")
        return undefined;
    const provider = connector.getBitcoinProvider();
    return provider.getPublicKey();
}
//# sourceMappingURL=wagmi.js.map